var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"83e9f14a624fe27dfe7507fb71e12fafb882e526"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["smarketerjobs-new@smarketer-gmbh"]={id:"83e9f14a624fe27dfe7507fb71e12fafb882e526"};
      